



























































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";
import HistoricoAtendimentos from "./HistoricoAtendimentos.vue";
import NovoAtendimento from "../modals/NovoAtendimento.vue";
import Tooltip from "@/shared/components/tooltip.vue";

@Component({
  components: {
    DataTable,
    HistoricoAtendimentos,
    NovoAtendimento,
    Tooltip,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class Atendimentos extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseAtendimentos: Promise<any[]> | null = null;
  loading = false;

  headersAtendimentos = [
    { value: "idAtendimento", text: "Número" },
    { value: "tipoAtendimento.descricao", text: "Tipo" },
    { value: "descricao", text: "Descrição" },
    { value: "dataAtendimento", text: "Data atendimento" },
    { value: "aberto", text: "Status" },
    { value: "quantidadeChamada", text: "Qtd. Chamadas" },
    { value: "usuario.nome", text: "Responsável" },
    { value: "actions", text: "", sortable: false }
  ];

  mounted() {
    this.fetchAtendimentos();
  }

  async fetchAtendimentos() {
    this.loading = true;
    try {
      this.promiseAtendimentos = await ConsultoresService.ListarAtendimentos(
        this.idConsultor,
        10
      );
    } finally {
      this.loading = false;
    }
  }

  async adicionarPlano() {
    const modal = this.$refs.novoAtendimento as NovoAtendimento;
    await modal.novoAtendimento();
    this.fetchAtendimentos();
  }
}
